import React, { Fragment, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import {
  classData,
  bookingData,
} from "../ClassManagement/PageComponents/index"; // Import mock data
import ClassTable from "../ClassManagement/PageComponents/ClassTable";
import ClassCard from "../ClassManagement/PageComponents/ClassCard";
import ClassFormModal from "../ClassManagement/PageComponents/ClassFormModal";
import BookingTable from "../ClassManagement/PageComponents/BookingTable";
import { Grid, List, Plus } from "react-feather";
import { useNavigate } from "react-router-dom";
import classnames from "classnames";
import "./PageComponents/Booking.scss";
import { getClassTypes } from "../../../../api-handle/classApi";

const ClassManagement = () => {
  const navigate = useNavigate();
  const [viewType, setViewType] = useState("table");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterDate, setFilterDate] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [activeTab, setActiveTab] = useState("classes");
  const [refresh, setRefresh] = useState(false);
  const [classTypes, setClassTypes] = useState([])
  const toggleView = () => {
    setViewType(viewType === "table" ? "cards" : "table");
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const openModal = (classItem = null) => {
    setSelectedClass(classItem);
    setModalOpen(true);
  };

  const handleDelete = (classItem) => {
    //`Deleting Class ID: ${classItem.id}`);
  };

  const fetchClassTypes = async () => {
    try {
      const response = await getClassTypes()
      setClassTypes(response?.classtypes)
    } catch (error) {
      console.log(error)
    }

  }

  useEffect(() => {
    fetchClassTypes()
  }, [])

  const filteredClasses = classData.filter((classItem) => {
    const matchesStatus =
      filterStatus === "all" || classItem.status === filterStatus;
    const matchesDate = !filterDate || classItem.date === filterDate;
    return matchesStatus && matchesDate;
  });

  return (
    <Fragment>
      <Breadcrumbs
        mainTitle="Class Management"
        parent="Academy Panel"
        title="Manage Classes & Bookings"
      />
      <Container fluid={true}>
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Nav
                  tabs
                  className="card-header-tabs"
                  style={{ cursor: "pointer" }}
                >
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "classes",
                      })}
                      onClick={() => toggleTab("classes")}
                    >
                      Manage Classes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "bookings",
                      })}
                      onClick={() => toggleTab("bookings")}
                    >
                      View Bookings
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                <TabContent activeTab={activeTab}>
                  {/* Classes Management Tab */}
                  <TabPane tabId="classes">
                    <div className="booking-controls-container">
                      {/* Filters */}
                      <div className="booking-status-filter">
                        <Input
                          type="date"
                          value={filterDate}
                          onChange={(e) => setFilterDate(e.target.value)}
                        />
                      </div>

                      {/* Toggle & Add Class */}
                      <div className="actions-container">
                        {/* <Button color="light" onClick={toggleView}>
                          {viewType === "table" ? (
                            <Grid size={18} />
                          ) : (
                            <List size={18} />
                          )}
                        </Button> */}
                        <button style={{
                          background: "#33bdbf",
                          display: "flex",
                          padding: "5px",
                          color: "white",
                          border: "none",
                          alignItems: "center",
                          borderRadius: "5px"
                        }} color="primary" onClick={() => openModal()}>
                          <Plus size={15} className="me-1" /> Add Class
                        </button>
                      </div>
                    </div>

                    {viewType === "table" ? (
                      <ClassTable
                        data={filteredClasses}
                        filterDate={filterDate}
                        type={"classes"}
                        onEdit={openModal}
                        onDelete={handleDelete}
                        refresh={refresh}
                      />
                    ) : (
                      <ClassCard
                        data={filteredClasses}
                        onEdit={openModal}
                        onDelete={handleDelete}
                      />
                    )}
                  </TabPane>

                  {/* Bookings Tab */}
                  <TabPane tabId="bookings">
                    <BookingTable data={bookingData} classes={filteredClasses} />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Add/Edit Class Modal */}
      <ClassFormModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        classData={selectedClass}
        onRefresh={() => setRefresh(!refresh)}
        classTypes={classTypes}
      />
    </Fragment>
  );
};

export default ClassManagement;
